import { func_file, isArrayNotEmpty, isNotNullUndefined } from 'functions';

export default function useExportData() {

    function exportData(data) {
        if(isArrayNotEmpty(data)) {
            // get header names
            const headers = [Object.keys(data[0])];

            // Columns Widths
            let columnWidths = headers[0].map((header, idx) => {
                return {
                wch: idx == 1 || idx == 2 ? 50 : header.length,
                };
            });

            // Set rows data
            let rows = data.map((rowDetail) => {
                return headers[0].map((header) =>
                  isNotNullUndefined(rowDetail?.[header])
                    ? rowDetail[header]
                    : ""
                );
            });

            func_file.generateFile_XLSX("Product Summary Report", "Product Summary Report", headers, rows, null, null, columnWidths);
        }
    }

    return exportData;
}